import React, { useEffect, useState } from "react"
import { View } from 'react-native';
import SupportViewModal from "../../utils/modals/SupportViewModal";
import { CommonSupportHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import OrderComponent from "../tab-component/OrderListComponent";

const OrderList = (props) => {

    const [supportModal, setSupportModal] = useState(false)

    const showSupportModal = () => {
        setSupportModal(true)
    }

    const closeSuportModal = () => {
        setSupportModal(false)
    }

    return (<View>
        <CommonSupportHeader navigation={props.navigation}
            title='My Orders' showBackpress={true}
            showSupportModal={showSupportModal} />
        <OrderComponent
            navigation={props.navigation}
            route={props.route} />
        <SupportViewModal showPopup={supportModal}
            closeModal={closeSuportModal} />
    </View>)
}

export default OrderList